<template>
  <div class="number-grow-warp">
    <span ref="numberGrow" :data-time="time" class="number-grow" :data-value="value">{{data}}</span>
  </div>
</template>

<script>
export default {
  props: {
    time: {
      type: Number,
      default: 0.6
    },
    value: {
      type: Number,
      default: 720000
    }
  },

  data() {
    return {
      data: 0
    };
  },

  methods: {
    numberGrow(ele) {
      let _this = this;

      let step = (_this.value * 10) / (_this.time * 1000);
      let current = 0;
      let start = 0;
      let t = setInterval(function() {
        // start += step;
        start+=parseInt(step)
        if (start > _this.value) {
          clearInterval(t);
          start = _this.value;
          t = null;
        }
        if (current === start) {
          return;
        }
        current = start;
        ele.innerHTML =
          current.toString().replace(/(\d)(?=(?:\d{3}[+]?)+$)/g, "$1,");
        // this.data = current
        //   // .toString()
        //   // .replace(/(\d)(?=(?:\d{3}[+]?)+$)/g, "$1,");
      }, 1);
    }
  },

  mounted() {
    this.numberGrow(this.$refs.numberGrow);
  },

  watch: {
    value() {
      this.numberGrow(this.$refs.numberGrow);
    }
  }
};
</script>

<style>
.number-grow-warp {
  transform: translateZ(0);
}
.number-grow {
  font-size: 24px;
  color: #2a2a2a;
  font-weight: 600;
}
</style>